const getDigitValOrDefault = (val, _default) => {
	try {
		return parseFloat(val);
	} catch {
		return _default;
	}
};

const checkTextIsDigit = (text) => {
	if (typeof text === "number" || (typeof text === "string" && !isNaN(text))) {
		return true;
	} else return false;
};

const getRandomIntInclusive = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min); // Максимум и минимум включаются
};

const roundFloat = ({ val, prec }) => {
	const tenToN = 10 ** prec;
	return Math.round(val * tenToN) / tenToN;
};

/**
 * Проверяет, является ли число целым положительным и выводит предупреждения
 * @param {object} props
 * @param {number} props.value - проверяемое число
 * @param {function} [props.setFetchStatus] - устанавливает статус алерта
 * @param {function} [props.setFetchStatusText] - устанавливает текст алерта
 * @returns {boolean}
 */
export const isPositiveInt = ({ value, setFetchStatus, setFetchStatusText }) => {
	if (Number.isNaN(value)) {
		setFetchStatus?.("failed");
		setFetchStatusText?.("Значение должно быть числом");
		return false;
	} else if (!Number.isInteger(value)) {
		setFetchStatus?.("failed");
		setFetchStatusText?.("Значение должно быть целым");
		return false;
	} else if (value <= 0) {
		setFetchStatus?.("failed");
		setFetchStatusText?.("Значение должно быть положительным");
		return false;
	}

	return true;
};

export { checkTextIsDigit, getDigitValOrDefault, getRandomIntInclusive, roundFloat };
